import CustomConfirmModal from './CustomConfirmModal';

export default ({
  type,
  content,
  item,
  onOk,
}) => {
  if (!item || !item.id) return;
  const mode = item.active ? 'Archive' : 'Activate';

  CustomConfirmModal({
    title: `${mode} ${type} '${item.name}'?`,
    content,
    okText: mode,
    cancelText: 'Cancel',
    onOk() {
      onOk();
    },
  });
};
